import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICategoryOrProduct } from "shared/hubrise/models"

const Delete = ({ categoryOrProduct }: { categoryOrProduct: ICategoryOrProduct }): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleClick = (): void => {
    navigate(catalogNavigation.editNextPath("products"))
    editor.categoryOrProduct.delete(categoryOrProduct)
  }

  return <Details.TopbarButton onClick={handleClick} code="delete" />
}

export default Delete
